  
import { cartReducer } from './actions';

const reducers = {
  cartReducer
};

export { reducers };